import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDistance',
  standalone: false,
})
export class TimeDistancePipe implements PipeTransform {
  transform(time: number, ...args: unknown[]): string {
    const now = Date.now();
    const diff = (now - time) / 1000;

    if (diff < 10) {
      return 'just now';
    }

    if (diff < 60) {
      const seconds = Math.floor(diff);
      return `${seconds} second${seconds === 1 ? '' : 's'} ago`;
    }

    if (diff < 3600) {
      const minutes = Math.floor(diff / 60);
      return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
    }

    if (diff < 86400) {
      const hours = Math.floor(diff / 3600);
      return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    }

    if (diff < 604800) {
      const days = Math.floor(diff / 86400);
      return `${days} day${days === 1 ? '' : 's'} ago`;
    }

    if (diff < 2592000) {
      const weeks = Math.floor(diff / 604800);
      return `${weeks} week${weeks === 1 ? '' : 's'} ago`;
    }

    if (diff < 31536000) {
      const months = Math.floor(diff / 2592000);
      return `${months} month${months === 1 ? '' : 's'} ago`;
    }

    const years = Math.floor(diff / 31536000);
    return `${years} year${years === 1 ? '' : 's'} ago`;
  }
}
